import { useCallback } from 'react'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { useToast } from '@hooks'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'
import { acrissTable, categoriesTable } from 'Pages/Admin/AdminMapping/@signals'
import { useSignal } from '@preact/signals-react'


export default function useAdminMultipleActions(selectedData, setSelectedRows, path) {
	const { showToast } = useToast()
	const isLoadingDelete = useSignal(false)

	const handleRemoveMultipleMappings = useCallback(() => {
		showToast.confirm(`Are you sure to delete multiple mappings?`, {
			onSubmit: () => {
				isLoadingDelete.value = true
				showToast.promise(postSubmit(`${path === MAPPING_TYPE.ACRISS ? BACKEND_APIS.CUSTOM_ACRISS : BACKEND_APIS.CUSTOM_CATEGORY}/disable`,
					{
						idCustom: selectedData.map(({ idCustom }) => idCustom)
					},
				).then(() => {
					if (path === MAPPING_TYPE.ACRISS) {
						acrissTable.value = [...acrissTable.value?.filter(e => selectedData.every(s => s.idCustom !== e.idCustom))]
					} else {
						categoriesTable.value = [...categoriesTable.value?.filter(e => selectedData.every(s => s.idCustom !== e.idCustom))]
					}
				}).catch(() => {
					showToast.error('Report execution failed, please try again.')
				})).finally(() => {
					setSelectedRows([])
					isLoadingDelete.value = false
				})
			}
		})
	}, [JSON.stringify(selectedData)])


	return {
		isLoadingDelete: isLoadingDelete.value,
		handleRemoveMultipleMappings
	}
}